import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Logo from '../components/Logo';
import Modal from '../components/Modal';

import './Image.css';

export default class Image extends Component {
  static propTypes = {
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
    inline: PropTypes.bool,
  };
  
  static defaultProps = {
    className: null,
    loading: false,
    inline: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      enlarge: false,
    };
  }

  classNames = ({
    className,
    loading,
    inline,
  }) => {
    const names = ['Image'];
    if (className) {
      names.push(className);
    }
    if (loading) {
      names.push('loading');
    }
    if (inline) {
      names.push('inline');
    }
    return names.join(' ');
  };

  handleEnlargeImg = () => {
    if (!this.props.loading) {
      this.setState({ enlarge: !this.state.enlarge });
    }
  }

  render(){
    const {
      className,
      loading,
      inline,
      alt,
      src,
    } = this.props;
    return (
      <div
        className={this.classNames({
          className,
          loading,
          inline,
        })}
        onClick={this.handleEnlargeImg}
      >
      <Modal
        close={this.state.enlarge}
      >
        <img
          alt={loading ? 'Loading' : alt}
          src={src}
          className={`${this.state.enlarge ? 'enlarge' : null}`}
        />
      </Modal>
        <img
          alt={loading ? 'Loading' : alt}
          src={src}
        />
        <Logo spin white className="Image-Loader" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.jsx